/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance, AxiosRequestConfig } from 'axios';

export type ApiResponse = {
  headers: any;
  statusCode: number;
};
export type ApiPostResponse = {
  headers: any;
  statusCode: number;
  data: any;
};
export type ApiError = {
  message?: string;
  response?: Response;
};

export const asyncGet = <T>(axiosInstance: AxiosInstance, url: string, config?: AxiosRequestConfig): Promise<T> =>
  axiosInstance.get(url, config).then((r) => (r?.data ? r?.data : {})) as Promise<T>;

export const asyncPost = (
  axiosInstance: AxiosInstance,
  url: string,
  data?: Record<string, unknown> | Record<string, unknown>[],
): Promise<ApiPostResponse> =>
  axiosInstance.post(url, data).then((r) => ({ headers: r?.headers, statusCode: r?.status, data: r?.data }));

export const asyncPut = (
  axiosInstance: AxiosInstance,
  url: string,
  data?: Record<string, unknown> | Record<string, unknown>[],
): Promise<ApiResponse> => axiosInstance.put(url, data).then((r) => ({ headers: r?.headers, statusCode: r?.status }));

export const asyncPatch = (
  axiosInstance: AxiosInstance,
  url: string,
  data?: Record<string, unknown> | Record<string, unknown>[],
): Promise<ApiResponse> => axiosInstance.patch(url, data).then((r) => ({ headers: r?.headers, statusCode: r?.status }));
